<template>
  <div
    v-loading="loading"
    class="recordsJustifFileInput"
    @click="handleFullClick"
  >
    <div class="recordsJustifFileInput__left">
      <md-icon name="attach_file" />
      <md-icon
        v-if="hasFile"
        class="recordsJustifFileInput__check"
        name="check_circle"
      />
      <div class="recordsJustifFileInput__title">
        <p>{{ document.title }}</p>
        <a
          v-if="hasFile"
          :href="document.document.url"
          target="_blank"
          class="recordsJustifFileInput__fileName"
        >{{ document.document.filename }}</a>
      </div>
    </div>
    <div
      class="recordsJustifFileInput__right"
      :class="{ hasFile }"
    >
      <div
        v-if="!hasFile"
        class="recordsJustifFileInput__input"
      >
        {{ $t('records.justif.browse')}}
      </div>
      <div
        v-else
        class="recordsJustifFileInput__actions"
      >
        <el-button
          type="basic"
          @click="handleClick"
        >
          {{ $t('records.justif.updateButton')}}
        </el-button>
        <div @click="handleDelete">
          <md-icon name="delete" />
        </div>
      </div>
    </div>
    <input
      :id="'file_' + document.id"
      class="recordsJustifFileInput__fileInput"
      type="file"
      @change="handleUpload"
    />
  </div>
</template>

<script>
export default {
  name: "RecordsJustifFileInput",
  props: {
    document: {
      type: Object,
      required: true
    },
    person: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    loading: false
  }),
  computed: {
    hasFile() {
      if (this.document.document || this.file) {
        return true
      }

      return false
    }
  },
  methods: {
    handleFullClick() {
      if (!this.hasFile) this.handleClick()
    },
    handleClick() {
      this.$el.querySelector('#file_' + this.document.id).click()
    },
    async handleUpload(e) {
      try {
        this.loading = true
        const file = e.target && e.target.files && e.target.files.length > 0 ? e.target.files[0] : false

        await this.$store.dispatch('recordsDocuments/uploadFile', {
          type: this.person.type,
          target_id: this.person.id,
          document_type_id: this.document.id,
          file
        })

        this.loading = false

        this.$notify({
          type: 'success',
          title: 'Succès',
          message: 'Fichier envoyé!'
        })

        await this.$store.dispatch('records/refreshCurrentRecord', { withPeople: false }, {
          root: true
        })
      } catch (error) {
        this.loading = false
        this.$notify({
          type: 'error',
          title: 'Erreur',
          message: 'Impossible d\'envoyer votre fichier!'
        })
      }

      // Reset input (hack)
      if (!/MSIE|Trident\//i.test(navigator.userAgent)) {
        e.target.value = ''
      }

      if (!/safari/i.test(navigator.userAgent)) {
        e.target.type = ''
        e.target.type = 'file'
      }
    },
    async handleDelete() {
      try {
        this.loading = true

        await this.$store.dispatch('recordsDocuments/deleteFile', {
          type: this.person.type,
          target_id: this.person.id,
          document_type_id: this.document.id
        })

        this.$notify({
          type: 'success',
          title: 'Succès',
          message: 'Fichier supprimé!'
        })

        this.loading = false
      } catch (error) {
        this.loading = false
        this.$notify({
          type: 'error',
          title: 'Erreur',
          message: 'Impossible de supprimer votre fichier!'
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
$c: '.recordsJustifFileInput';

#{$c} {
  @include respond-above(xs) {
    display: flex;
  }
  justify-content: space-between;
  border: solid 1px #dcdfe6;
  padding: 10px;
  border-radius: 4px;
  margin-top: 25px;
  margin-bottom: 25px;
  cursor: pointer;

  &__left,
  &__right {
    display: flex;
    align-items: center;
  }

  &__left {
    position: relative;

    p {
      margin: 0;
    }

    #{$c}__fileName {
      margin-top: 4px;
      font-style: italic;
      text-decoration: underline !important;
      color: $--color-text-regular;
      word-break: break-word;
    }

    i {
      margin-right: 30px;
      font-size: 28px;
      color: #c0c4cc;

      &#{$c}__check {
        position: absolute;
        font-size: 12px;
        color: $--color-success;
        top: 3px;
        left: 13px;
      }
    }
  }

  &__right {
    padding-right: 15px;
    padding-left: 15px;
    font-size: 14px;
    border-left: 1px solid rgba(154, 147, 140, 0.33);
    color: $--color-primary;

    &.hasFile {
      border: none;
    }

    #{$c}__input,
    #{$c}__actions {
      display: flex;
      align-items: center;
    }

    #{$c}__actions {
      i {
        margin-left: 15px;
        color: $--color-text-regular;
      }
    }
  }

  &__fileInput {
    display: none;
  }
}
</style>